import { http } from '../../config/axios'

 const findServico = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/propostacredito/processproposta/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findServico', error)
      throw Error(error.response.data)
    })
}

export default findServico;
